import React, { Component } from "react";
import EditRefereeDialog from "../../components/schedule/EditRefereeDialog";
import CreateIcon from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";
import { languages } from "../../constants/languages";
import Button from "@material-ui/core/Button";
import { isNormalInteger } from "../../util/IsNormalInteger";

class EditRefereeContainer extends Component {
  state = {
    open: false,
    name: "",
    submitDisabled: true,
    refereeList: "",
    country: "",
    location: {},
    availability: {},
    divisionsReferee: "all",
    maxMatches: "",
    excludeTeams: [],
    roles: "all",
  };

  toggleDialog = () => {
    this.setState({ open: !this.state.open });
  };

  UNSAFE_componentWillMount = () => {
    const referee = this.props.referee;
    if (referee) {
      this.updateState(referee);
    }
  };

  updateState = (referee) => {
    let newState = {
      name: referee.name || "",
      country: referee.country || "none",
      // email: referee.email || "",
      // extraField: referee.extraField || "",
      location: referee.location || {},
      availability: referee.availability || {},
      divisionsReferee: referee.divisionsReferee || "all",
      maxMatches: referee.maxMatches || "",
      excludeTeams: referee.excludeTeams || [],
      roles: referee.roles || "all",
    };
    Object.keys(this.props.tournament.infoFieldsReferees || {}).map((key) => {
      return (newState[key] = referee[key] || "");
    });
    this.setState(newState);
  };

  handleLocationChange = (event, sportParkId) => {
    let currentLocation = this.state.location;
    let newValue = event.target.value;
    if (newValue === "selection") {
      newValue = [];
    }

    currentLocation[sportParkId] = newValue;
    this.setState({ location: currentLocation, submitDisabled: false });
  };

  handleFieldsChange = (event, sportParkId) => {
    let currentLocation = this.state.location;
    let newValue = event.target.value;

    currentLocation[sportParkId] = newValue;
    this.setState({ location: currentLocation, submitDisabled: false });
  };

  handleAvailabilityChange = (event, dayId) => {
    let currentAvailability = this.state.availability;
    let newValue = event.target.value;
    if (newValue === "selection") {
      newValue = { start: "", end: "" };
    }

    currentAvailability[dayId] = newValue;
    this.setState({ availability: currentAvailability, submitDisabled: false });
  };

  handleTimesStartChange = (value, dayId) => {
    console.log(value);
    let currentAvailability = this.state.availability;
    let newValue = value;
    let currentTimes = currentAvailability[dayId] || { start: "", end: "" };
    currentTimes["start"] = newValue ? newValue.format("HH:mm") : "";
    currentAvailability[dayId] = currentTimes;
    this.setState({ availability: currentAvailability, submitDisabled: false });
  };

  handleTimesEndChange = (value, dayId) => {
    let currentAvailability = this.state.availability;
    let newValue = value;
    let currentTimes = currentAvailability[dayId] || { start: "", end: "" };
    currentTimes["end"] = newValue ? newValue.format("HH:mm") : "";
    currentAvailability[dayId] = currentTimes;
    this.setState({ availability: currentAvailability, submitDisabled: false });
  };

  handleDivisionsChange = (event) => {
    let currentDivisions = this.state.divisionsReferee;
    let newValue = event.target.value;
    if (newValue === "selection") {
      newValue = [];
    }

    currentDivisions = newValue;
    this.setState({
      divisionsReferee: currentDivisions,
      submitDisabled: false,
    });
  };

  handleChange = (event) => {
    let newState = {};
    newState[event.target.name] = event.target.value;
    if (event.target.name === "name" || event.target.name === "refereeList") {
      if (event.target.value.length > 0) {
        newState["submitDisabled"] = false;
      } else {
        newState["submitDisabled"] = true;
      }
    } else if (this.props.referee) {
      newState["submitDisabled"] = false;
    }
    this.setState(newState);
  };

  handleMaxMatchesChange = (event) => {
    let newState = { submitDisabled: false };
    newState[event.target.name] = event.target.value;
    if (isNormalInteger(event.target.value) || event.target.value === "") {
      this.setState(newState);
    }
  };

  handleRolesChange = (event) => {
    let currentRoles = this.state.roles;
    let newValue = event.target.value;
    if (newValue === "selection") {
      newValue = [];
    }

    currentRoles = newValue;
    this.setState({
      roles: currentRoles,
      submitDisabled: false,
    });
  };

  handleExcludeTeamsChange = (event, newTeams) => {
    let currentTeams = this.state.excludeTeams;
    let newValue = newTeams.map((t) => t.id);
    currentTeams = newValue;
    this.setState({
      excludeTeams: currentTeams,
      submitDisabled: false,
    });
  };

  handleKeyDown = (e) => {
    if (e.keyCode === 9) {
      // tab was pressed
      // get caret position/selection
      var start = e.target.selectionStart;
      var end = e.target.selectionEnd;

      var target = e.target;
      var value = target.value;
      // set textarea value to: text before caret + tab + text after caret
      target.value = value.substring(0, start) + "\t" + value.substring(end);
      // put caret at right position again (add one for the tab)
      this.selectionStart = this.selectionEnd = start + 1;

      // prevent the focus lose
      e.preventDefault();
      this.handleChange(e);
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({ submitDisabled: true });
    this.toggleDialog();
    const refereesRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("referees");

    let referee = {};
    let refereeDoc = refereesRef.doc();
    if (this.props.referee) {
      referee = this.props.referee;
      refereeDoc = refereesRef.doc(this.props.referee.id);
    }

    // division changes
    referee["name"] = this.state.name;
    referee["country"] = this.state.country;
    referee["location"] = this.state.location;
    referee["availability"] = this.state.availability;
    referee["divisionsReferee"] = this.state.divisionsReferee;
    referee["maxMatches"] = this.state.maxMatches;
    referee["excludeTeams"] = this.state.excludeTeams;
    referee["roles"] = this.state.roles;
    Object.keys(this.props.tournament.infoFieldsReferees || {}).map((key) => {
      return (referee[key] = this.state[key] || "");
    });

    refereeDoc
      .set(referee)
      .then(() => {
        if (this.props.referee) {
          this.setState({ submitDisabled: true });
        } else {
          let initialState = {
            submitDisabled: true,
            name: "",
          };
          Object.keys(this.props.tournament.infoFieldsReferees || {}).map(
            (key) => {
              return (initialState[key] = "");
            }
          );
          this.setState(initialState);
        }
      })
      .catch((error) => {
        this.setState({ submitDisabled: false });
      });
  };

  handleSubmitMultiple = (e) => {
    e.preventDefault();
    this.setState({ submitDisabled: true });
    const db = window.firebase.firestore();
    let batch = db.batch();
    var refereesRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("referees");
    let splitted = this.state.refereeList.split("\n");
    for (let i in splitted) {
      let split = splitted[i];
      if (split !== "" && split !== " ") {
        let splittedSplit = split.split("\t");
        let refereeData = {
          name: splittedSplit[0],
        };
        let refereeDoc = refereesRef.doc();
        batch.set(refereeDoc, refereeData);
      }
    }
    batch
      .commit()
      .then(() => {
        let initialState = {
          submitDisabled: true,
          refereeList: "",
          country: "none",
        };
        this.setState(initialState);
        this.toggleDialog();
      })
      .catch((error) => {
        this.setState({ submitDisabled: false });
      });
  };

  render() {
    let days = [{ date: this.props.tournament.date, id: "0" }].concat(
      this.props.days
    );

    return (
      <div>
        {this.props.referee ? (
          <IconButton
            aria-label="Change"
            style={{ padding: 5 }}
            onClick={this.toggleDialog}
            disabled={this.props.disabled}
          >
            <CreateIcon />
          </IconButton>
        ) : (
          <Button
            size="small"
            variant="outlined"
            color="default"
            onClick={this.toggleDialog}
          >
            {this.props.tournament.useJudges
              ? languages.referees.addJudge
              : languages.referees.addReferee}
          </Button>
        )}
        <EditRefereeDialog
          tournament={this.props.tournament}
          referee={this.props.referee}
          toggleDialog={this.toggleDialog}
          handleChange={this.handleChange}
          handleSubmit={this.handleSubmit}
          handleSubmitMultiple={this.handleSubmitMultiple}
          handleKeyDown={this.handleKeyDown}
          {...this.state}
          sportParks={this.props.sportParks}
          handleLocationChange={this.handleLocationChange}
          handleFieldsChange={this.handleFieldsChange}
          days={days}
          handleAvailabilityChange={this.handleAvailabilityChange}
          handleTimesStartChange={this.handleTimesStartChange}
          handleTimesEndChange={this.handleTimesEndChange}
          divisions={this.props.divisions}
          handleDivisionsChange={this.handleDivisionsChange}
          handleMaxMatchesChange={this.handleMaxMatchesChange}
          handleRolesChange={this.handleRolesChange}
          allTeams={this.props.allTeams}
          allTeamsByKey={this.props.allTeamsByKey}
          handleExcludeTeamsChange={this.handleExcludeTeamsChange}
        />
      </div>
    );
  }
}

export default EditRefereeContainer;
